import { useMemo } from "react";
import { Tooltip } from "reactstrap";
import { faTriangleExclamation } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useVisible } from "../../../../../../utils/hooks/useVisible";

const ErrorTooltip = ({ row, errors }) => {
    const error = useMemo(() => {
        if (!errors?.[row?.id]) {
            return false;
        }
        return Object.values(errors?.[row?.id]).find((err) => !!err)
    }, [errors, row.id]);

    const { visible, toggle } = useVisible();

    if (!error) {
        return null;
    }

    const id = `timesheet-${row.original.user.id}-row-${row.id}-error`;

    return (
        <span id={id}>
            <FontAwesomeIcon
                className="cursor-pointer text-red"
                icon={faTriangleExclamation}
                size="lg"
            />
            <Tooltip target={id} isOpen={visible} toggle={toggle}>
                <span className="text-sm font-weight-bolder px-2 m-2">
                    {error}
                </span>
            </Tooltip>
        </span>
    );
}

export default ErrorTooltip;
